import '@fontsource-variable/inter';
import '@fontsource-variable/inter/wght-italic.css';
import '@smastrom/react-rating/style.css';
import './styles.scss';

import * as ReactDOM from 'react-dom/client';

import { StrictMode } from 'react';
import AppRoutes from './app/app.routes';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <StrictMode>
    <AppRoutes />
  </StrictMode>
);
